<template>
  <div
    class="image-list-container-wrapper"
  >
    <div
      class="image-list-container"
    >
      <div>
        <el-button
          class="favorite-button"
          type="primary"
          @click="handleDataList()"
          :loading="loading['table']"
        >
          切换{{ is_favorite_task ? '普通' : '收藏' }}列表
        </el-button>
      </div>
      <el-table
        :data="dataList"
        border
        style="width: 100%"
        v-loading="loading['table']"
        max-height="550px"
      >
        <el-table-column
          align="center"
          label="图片"
          min-width="200"
        >
          <template slot-scope="{row}">
            <el-image
              v-if="row.result"
              class="img"
              :src="row.result.details[0].path"
              :preview-src-list="row.result.details.map(item => item.path)"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="type_text"
          label="类型"
          min-width="100"
        />
        <el-table-column
          align="center"
          prop="status_text"
          label="状态"
          min-width="80"
        />
        <el-table-column
          align="center"
          prop="start_datetime"
          label="开始生成时间"
          min-width="130"
        />
        <el-table-column
          align="center"
          prop="end_datetime"
          label="结束生成时间"
          min-width="130"
        />
        <el-table-column
          align="center"
          label="操作"
          min-width="100"
        >
          <template slot-scope="{row, index}">
            <el-button
              class="favorite-button"
              v-if="!row['is_favorite_task'] && !is_favorite_task"
              plain
              type="primary"
              @click="favoriteLogTask(row)"
              :loading="row.favorite_loading"
            >
              收藏
            </el-button>
            <el-button
              v-if="!is_favorite_task"
              class="favorite-button"
              plain
              type="danger"
              @click="delLogTask(row, index)"
              :loading="row.delete_loading"
            >
              删除
            </el-button>
            <el-button
              class="favorite-button"
              v-if="is_favorite_task"
              plain
              type="primary"
              @click="cancelFavoriteLogTask(row)"
              :loading="row.cancel_favorite_loading"
            >
              取消收藏
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        background
        :current-page.sync="paginationConfig.currentPage"
        :page-sizes="paginationConfig.pageSizes"
        :page-size="paginationConfig.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="paginationConfig.dataTotal"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import {
  getUserTask,
  delLogTask,
  getFavoriteList, updateFavorite
} from '@/api/characterGeneratePicture.js'

export default {
  name: 'UserImageInfo',
  components: {},
  data() {
    return {
      loading: {
        table: false
      },
      dataList: [],
      paginationConfig: {
        currentPage: 1,
        pageSizes: [10, 15, 20],
        pageSize: 10,
        dataTotal: 0
      },
      is_favorite_task: false
    }
  },
  mounted() {
  },
  created() {
    this.getDataList()
  },
  methods: {
    handleSizeChange(value) {
      this.paginationConfig.pageSize = value
      this.paginationConfig.currentPage = 1
      this.getDataList()
    },
    handleCurrentChange(value) {
      this.paginationConfig.currentPage = value
      this.getDataList()
    },
    // 图片没有生成完成的情况下，进行重新请求
    retransmissionMechanism(details) {
      // if (details.some(item => [1, 2].includes(item.status))) {
      //   setTimeout(() => {
      //     this.getDataList()
      //   }, 3000)
      // }
    },
    delLogTask(row, index) {
      this.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.delete_loading = true
        delLogTask(row.id).then(rep => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.dataList.splice(index, 1)
          if (this.dataList.length === 0) {
            this.paginationConfig.pageSize = 1
            this.getDataList()
          }
        }).finally(() => {
          row.delete_loading = false
        })
      }).catch(() => {
      })
    },
    cancelFavoriteLogTask(row) {
      this.$confirm('是否取消收藏?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.cancel_favorite_loading = true
        updateFavorite(row.id).then(rep => {
          this.$message({
            type: 'success',
            message: '取消收藏成功!'
          })
          this.getDataList()
        }).finally(() => {
          row.cancel_favorite_loading = false
        })
      }).catch(() => {
      })
    },
    favoriteLogTask(row) {
      row.favorite_loading = true
      updateFavorite(row.id).then(rep => {
        this.$message({
          type: 'success',
          message: '收藏成功!'
        })
        this.getDataList()
      }).finally(() => {
        row.favorite_loading = false
      })
    },
    handleDataList() {
      this.is_favorite_task = !this.is_favorite_task
      this.getDataList()
    },
    getDataList() {
      let method
      if (this.is_favorite_task) {
        method = getFavoriteList({
          limit: this.paginationConfig.pageSize,
          page: this.paginationConfig.currentPage
        })
      } else {
        method = getUserTask({
          limit: this.paginationConfig.pageSize,
          page: this.paginationConfig.currentPage
        })
      }
      this.loading.table = true
      method.then(rep => {
        const dataList = rep.data.list.data
        dataList.forEach(item => {
          item.delete_loading = false
        })
        this.paginationConfig.dataTotal = rep.data.list.total
        this.dataList = dataList
      }).finally(() => {
        this.loading.table = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
@sideContentBackground: #eeeeee;
@sideScrollbar: rgb(55, 61, 68);

.image-list-container-wrapper {

}

.pagination-container{
  margin-top: 20px;
}

.image-list-container {
  .el-table {
    margin-top: 20px;
    font-size: 22px;
  }
}

/deep/ .image-list-container .favorite-button {
  font-size: 18px;
}

.img{
  width: 178px;
  height: 178px;
}

// 生成宽度工具类
.width-loop(@i) when (@i <= 300) {
  .w-@{i} {
    width: ~"@{i}px";
  }
  .width-loop(@i + 1);
}
.width-loop(1); // 启动循环

// 生成高度工具类（可选）
.height-loop(@i) when (@i <= 300) {
  .h-@{i} {
    height: ~"@{i}px";
  }
  .height-loop(@i + 1);
}
.height-loop(1);
</style>

<style >
.el-dialog__wrapper .el-dialog__title{
    font-size: 28px !important;
}
.el-dialog__wrapper .el-icon-close::before{
  font-size: 22px;
}
</style>
